<template>
  <div id="grad" class="w-screen h-screen">
    <div id="colorgrad"></div>
    <div id="all">
      <div id="container">
        <div v-if="!fetching">
          <div id="logo">
            <img src="../../assets/qwello-logo.svg" alt="Qwello GmbH" />
          </div>
          <div id="text">
            <h2>{{ $t('tech.register_confirm_title') }}</h2>
            <p>{{ $t('tech.register_confirm_html') }}</p>
          </div>
          <div id="btn" :class="isMobile ? 'block' : 'hidden'">
            <a v-bind:href="appUrl" target="_blank">{{
              $t('tech.register_confirm_to_app')
            }}</a>
          </div>

          <section :data-show="tempPass.length > 0" id="temp_pass">
            <div class="flex justify-center text-12px md:text-14px">
              <div class="intro text-white">
                {{ $t('tech.login_site_no_phone') }}
              </div>
              <div class="intro_link ml-2 text-qwellow">
                {{ $t('tech.login_site_tmp_pwd') }}
              </div>
            </div>
            <p class="number" :class="tempPass ? 'block' : 'hidden'">
              {{ tempPass }}
            </p>
            <p class="validity" :class="tempPass ? 'block' : 'hidden'">
              {{ $t('tech.login_site_tmp_validity') }}
            </p>
            <p class="error" :class="isError ? 'block' : 'hidden'">
              {{ errMessage }}
            </p>
          </section>
        </div>
        <Spinner v-else />
        <bottom-icons />
        <div v-if="isMobile" class="appstore-links">
          <a v-if="isiOS" class="storeLink" :href="appStoreLinks.ios">
            <img
              class="inline storeImage"
              src="~@/assets/apple-app-store-btn-EN.svg"
            />
          </a>
          <a v-else class="storeLink" :href="appStoreLinks.android">
            <img
              class="inline storeImage"
              src="~@/assets/google-play-store-btn-EN.svg"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import BottomIcons from '../../components/Tech/BottomIcons.vue';
import appStoreLinks from '../../data/appStoreLinks';
import Spinner from '../../components/shared/Spinner.vue';

export default {
  components: {
    BottomIcons,
    Spinner,
  },
  data() {
    return {
      appUrl: '',
      isError: false,
      errMessage: '',
      tempPass: '',
      fetching: true,
      appStoreLinks,
      isiOS: navigator.userAgent.includes('iPhone'),
    };
  },
  computed: {
    isMobile() {
      return (
        navigator.userAgent &&
        (navigator.userAgent.includes('Android') ||
          navigator.userAgent.includes('iPhone'))
      );
    },
  },
  async beforeCreate() {
    const formData = new URLSearchParams();
    formData.append('user_id', this.$route.params.userId);
    formData.append('user_token', this.$route.params.token);
    const res = await fetch(
      `${process.env.VUE_APP_USER_SERVICE_URL}/register/confirm`,
      {
        method: 'POST',
        body: formData,
      }
    );
    if (res.status !== 200) {
      switch (res.status) {
        case 401:
          return this.$router.push({
            name: 'tech-error',
            params: { err_msg: 'tech.err_invalid_token' },
          });
        case 404:
          return this.$router.push({
            name: 'tech-error',
            params: { err_msg: 'tech.err_user_not_found' },
          });
        default:
          return this.$router.push({
            name: 'tech-error',
            params: { err_msg: 'tech.err_unknown' },
          });
      }
    }
    // check to see if user signed up via the website.
    // rename data to 'confirmationData' to prevent same named variables
    const { data: confirmationData } = await res.json();
    if (confirmationData.platform === 'web') {
      this.fetching = false;
      return false;
    }
    this.appUrl = `/app/${this.$route.params.lang}/registration-confirmed/${this.$route.params.userId}/${this.$route.params.token}`;
    this.isError = false;
    this.tempPass = '';
    const response = await fetch(
      // eslint-disable-next-line
      `${process.env.VUE_APP_USER_SERVICE_URL}/register/get-temp-pass?user_id=${this.$route.params.userId}&user_token=${this.$route.params.token}&language=${i18n.locale}`
    );
    const body = await response.json();

    this.fetching = false;
    if (response.status === 200) {
      const { data } = body;
      this.tempPass = data.temp_pass;
      return true;
    }
    this.isError = true;
    this.errMessage = body.message;
    return true;
  },
};
</script>

<style scoped>
#grad {
  background-image: url(~@/assets/registration_confirmation_lp.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#colorgrad {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: -webkit-linear-gradient(
    left,
    rgba(43, 64, 71, 0.3),
    rgba(43, 64, 71, 1)
  );
  background: -o-linear-gradient(
    left,
    rgba(43, 64, 71, 0.3),
    rgba(43, 64, 71, 1)
  );
  background: linear-gradient(
    to right,
    rgba(43, 64, 71, 0.3),
    rgba(43, 64, 71, 1)
  );
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
}

#all {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 40;
  overflow: auto;
  text-align: center;
}

#container {
  width: 70%;
  height: 100%;
  align-content: center;
  text-align: center;
  margin: 0 auto;
}

#logo {
  width: 100%;
  display: block;

  margin: 10% 0;
}

#logo img {
  margin-left: auto;
  margin-right: auto;
}

#text {
  text-align: center;
  display: block;
  width: 100%;
}

h2 {
  line-height: 25px;
  color: #fff;
  font-family: 'Foco', sans-serif;
  font-weight: 700;
  letter-spacing: 0.5px;
}

p {
  font-size: 16px;
  line-height: 25px;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
}

#btn {
  margin: 10% 0;
}

#btn a {
  background-color: #2b4047;
  border: 2px solid #ffdf22;
  border-radius: 50px;
  color: #fff;
  display: inline-block;
  font-family: 'Foco', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  text-decoration: none;
  width: 260px;
  height: 44px;
  min-height: 44px;
}

#btn a:hover {
  background-color: #ffdf22;
  color: #2b4047;
  transition: 0.1s;
}
#temp_pass {
  visibility: hidden;
}
#temp_pass[data-show='true'] {
  visibility: visible;
}

#temp_pass {
  margin-top: 50px;
  margin-bottom: 50px;
}

#temp_pass p.intro {
  font-size: 14px;
  max-width: none;
}

#temp_pass a {
  color: #ffdf22;
}

#temp_pass .number {
  background-color: rgba(255, 223, 34, 0.1);
  width: 86px;
  height: 38px;
  text-align: center;
  color: #ffdf22;
  font-size: 18px;
  font-weight: 700;
  line-height: 38px;
  vertical-align: middle;
  margin: 0 auto;
}

#temp_pass .validity {
  font-size: 14px;
  opacity: 0.5;
  font-weight: 700;
  margin-top: 0;
  user-select: none;
}

.hidden {
  visibility: hidden !important;
}
.storeLink {
  display: block;
  margin: 0 auto;
  max-width: 130px;
}
.storeImage {
  max-width: 100%;
}
</style>
